export default __webpack_public_path__ + "static/media/SG-Yellow-0001.8a40de0f.png";